export const modalInputFieldStyle = {
  height: '27px',
  minWidth: '270px',
  WebkitBoxShadow: '0 0 0 1000px white inset',
  marginTop: '4px',
};
